import {
    createRouter,
    createWebHistory,
    RouteLocationNormalized,
    RouteLocationNormalizedLoaded,
    Router,
    RouteRecordRaw,
} from 'vue-router'
import authorizeTechnician from '@/router/middlewares/authorizeTechnician'
import authorizeAuthenticated from '@/router/middlewares/authorizeAuthenticated'
import hasAccessToPage from '@/router/middlewares/hasAccessToPage'

export enum appRouteNames {
    WELCOME = 'welcome',
    SETTINGS = 'settings',
    PATREON = 'patreon',
    AUTH_CALLBACK = 'auth-callback',
    AUTH_POPUP_CALLBACK = 'auth-popup-callback',
    AUTH_CALLBACK_ERROR = 'auth-callback-error',
}

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: '',
        meta: {
            isPublic: true,
        },
        beforeEnter: authorizeAuthenticated,
        component: () =>
            import(/* webpackChunkName: "welcome" */ '@/views/Welcome.vue'),
    },
    {
        path: '/welcome',
        name: 'welcome',
        meta: {
            isPublic: true,
        },
        component: () =>
            import(/* webpackChunkName: "welcome" */ '@/views/Welcome.vue'),
    },
    {
        path: '/settings',
        name: 'settings',
        meta: {
            layout: 'AppLayoutDashboard',
        },
        component: () =>
            import(/* webpackChunkName: "settings" */ '@/views/Settings.vue'),
    },
    {
        path: '/patreon',
        name: 'patreon',
        meta: {
            layout: 'AppLayoutDashboard',
        },
        component: () =>
            import(/* webpackChunkName: "patreon" */ '@/views/Patreon.vue'),
    },
    {
        path: '/auth-callback',
        name: 'auth-callback',
        component: () =>
            import(
                /* webpackChunkName: "auth-callback" */ '@/views/auth/AuthCallback.vue'
            ),
    },
    {
        path: '/auth-popup-callback',
        name: 'auth-popup-callback',
        component: () =>
            import(
                /* webpackChunkName: "auth-popup-callback" */ '@/views/auth/AuthPopupCallback.vue'
            ),
    },
    {
        path: '/auth-callback-error',
        name: 'auth-callback-error',
        meta: {
            isPublic: true,
        },
        component: () =>
            import(
                /* webpackChunkName: "auth-callback-error" */ '@/views/auth/AuthCallbackError.vue'
            ),
    },
    { path: '/:notFound(.*)', redirect: '/' },
]

const router: Router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalizedLoaded,
        savedPosition
    ) {
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0, left: 0 }
    },
})

router.beforeEach(hasAccessToPage)

export default router
